import { map } from "rxjs";
import { apiService } from "../../ApiService";
import { Plan } from "../../../model/Plan";

export const getPlan = (organizationName: string, publicId: string) => {
  return apiService
    .get<{ plan: Plan }>({
      path: `v1/plans/${organizationName}/${publicId}`,
    })
    .pipe(map((res) => res.plan));
};
